import Store from 'src/store/index'
import date from 'src/store/modules/date/index'

const initWarehose = {
  action: 'INSERT', // INSERT || UPDATE || DELETE || PREVIEW
  id: null,
  isEdit: false,
  name: null,
  pic: null,
  email: null,
  phone: null,
  isLocationPickup: null,
  description: null,
  province: null,
  city: null,
  districtId: null,
  zipcode: null,
  address: null,
  lat: null,
  lng: null
}

const initForm = {
  id: null,
  name: null,
  npwpNo: null,
  npwpFile: null,
  pic: null,
  companyType: null,
  type: null,
  email: null,
  phone: null,
  province: null,
  city: null,
  districtId: null,
  zipcode: null,
  address: null,
  description: null,
  paymentTerm: null,
  dueDate: null,
  accountNo: null,
  accountName: null,
  bankName: null,
  accountBranch: null,
  warehouses: []
}

export default function () {
  return {
    visibleColumns: [
      'name',
      'pic',
      'phone',
      'email',
      'address',
      'verification_status'
    ],

    columns: [
      {
        name: 'name',
        field: (row) => {
          return (
            `<a href="/vendor/form/preview/${row.id}/${encodeURIComponent(
              row.name
            ).replace(/\./g, '')}" class="goto-preview-page">${row.name}</a>` ||
            '-'
          )
        },
        label: 'Nama Vendor',
        sortable: true,
        align: 'left',
        rowClass: 'text-primary'
      },
      {
        name: 'npwp_no',
        field: (row) => {
          return row.npwp_no || '-'
        },
        label: 'No. NPWP',
        sortable: true,
        align: 'left'
      },
      {
        name: 'pic_data',
        field: (row) => {
          return Array.isArray(row.pic_data) && row.pic_data.length === 1
            ? row.pic_data[0].name
            : Array.isArray(row.pic_data) && row.pic_data.length > 1
              ? row.pic_data[0].name + ' & lainnya'
              : '-'
        },
        label: 'Nama PIC',
        sortable: true,
        align: 'left'
      },
      {
        name: 'companyType',
        field: (row) => {
          return row.companyType || '-'
        },
        label: 'Bentuk Badan Usaha',
        sortable: true,
        align: 'left'
      },
      {
        name: 'type',
        field: (row) => {
          return row.type || '-'
        },
        label: 'Jenis Vendor',
        sortable: true,
        align: 'left'
      },
      {
        name: 'phone',
        field: (row) => {
          return row.phone ? `<a href="tel:${row.phone}">${row.phone}</a>` : '-'
        },
        label: 'No. Telepon',
        sortable: true,
        align: 'left'
      },
      {
        name: 'email',
        field: (row) => {
          return row.email
            ? `<a href="mailto:${row.email}">${row.email}</a>`
            : '-'
        },
        label: 'Email',
        sortable: true,
        align: 'left'
      },
      {
        name: 'created_at',
        field: (row) => {
          return date.actions.COMMON_DATE(Store(), {
            date: new Date(row.created_at),
            useSecond: true
          })
        },
        label: 'Tanggal Pendaftaran',
        sortable: true,
        align: 'left'
      },
      {
        name: 'payment_term',
        field: (row) => {
          return row.payment_term || '-'
        },
        label: 'Ketentuan Pembayaran',
        sortable: true,
        align: 'left'
      },
      {
        name: 'due_date',
        field: (row) => {
          return row.due_date || '-'
        },
        label: 'Jatuh Tempo',
        sortable: true,
        align: 'left'
      },
      {
        name: 'account_no',
        field: (row) => {
          return row.account_no || '-'
        },
        label: 'No. Rekening',
        sortable: true,
        align: 'left'
      },
      {
        name: 'account_name',
        field: (row) => {
          return row.account_name || '-'
        },
        label: 'Nama Pemilik Rekening',
        sortable: true,
        align: 'left'
      },
      {
        name: 'bank_name',
        field: (row) => {
          return row.bank_name || '-'
        },
        label: 'Nama Bank',
        sortable: true,
        align: 'left'
      },
      {
        name: 'account_branch',
        field: (row) => {
          return row.account_branch || '-'
        },
        label: 'Cabang Pembukaan Rekening',
        sortable: true,
        align: 'left'
      },
      {
        name: 'description',
        field: (row) => {
          return row.description || '-'
        },
        label: 'Deskripsi',
        sortable: true,
        align: 'left'
      },
      {
        name: 'address',
        field: (row) => {
          return row?.address
            ? `<div class="cell-address">${row.address}</div>`
            : '-'
        },
        label: 'Alamat',
        sortable: true,
        align: 'left'
      },
      {
        name: 'warehouse',
        field: (row) => {
          return row?.total_warehouse ? `${row.total_warehouse} gudang` : '-'
        },
        label: 'Jumlah Gudang',
        sortable: true,
        align: 'left'
      },
      {
        name: 'verified_supplier_status',
        field: (row) => {
          return (
            {
              WAITING:
                '<div role="alert" class="custom-badge custom-badge-purple">Menunggu Konfirmasi</div>',
              COMPLETED:
                '<div role="alert" class="custom-badge custom-badge-green">Lengkap</div>',
              REVISE:
                '<div role="alert" class="custom-badge custom-badge-red">Ditolak</div>'
            }[row?.verified_supplier_status] ||
            '<div role="alert" class="custom-badge custom-badge-grey">Belum Unggah</div>'
          )
        },
        label: 'Dokumen Legalitas',
        sortable: true,
        align: 'left'
      },

      {
        name: 'digital_invoice_status',
        field: (row) => {
          return row.digital_invoice_status === 'ACTIVE'
            ? '<div role="alert" class="custom-badge custom-badge-green">Aktif</div>'
            : '<div role="alert" class="custom-badge custom-badge-red">Tidak Aktif</div>'
        },
        label: 'Digital Invoice',
        sortable: true,
        align: 'left'
      },
      {
        name: 'supplier_status',
        field: (row) => {
          return row.supplier_status === 'ACTIVE'
            ? '<div role="alert" class="custom-badge custom-badge-green">Aktif</div>'
            : '<div role="alert" class="custom-badge custom-badge-red">Tidak Aktif</div>'
        },
        label: 'Status IMS',
        sortable: true,
        align: 'left'
      },
      {
        name: 'deleted_at',
        field: 'deleted_at',
        label: 'Tanggal Nonaktif',
        sortable: true,
        align: 'left',
        commonDate: true
      }
    ],

    filterResponse: {},

    warehouseDefault: JSON.parse(JSON.stringify(initWarehose)),
    warehouseForm: initWarehose,

    formDefault: JSON.parse(JSON.stringify(initForm)),
    form: initForm
  }
}
